import React from "react";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

export default function CommonModal({
  open,
  // setOpen,
  handleClose,
  title,
  cancelText = "Cancel",
  cancelProps = { variant: "outlined" },
  submitText = "Submit",
  submitProps = { variant: "outlined" },
  children,
  width = 600,
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      BackdropProps={{
        sx: {
          backgroundColor: "#0A0C10B2", // Custom overlay color
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { sm: width, xs: "90%" },
          maxHeight: "90vh",
          bgcolor: "#1D1D1F",
          borderRadius: "10px",
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
          p: 3,
          border: "1px solid #CFFF04"
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" color="#D6D6D6" fontWeight={500}>
            {title}
          </Typography>
          <IconButton onClick={handleClose} sx={{ color: "#D6D6D6" }}>
            <HighlightOffIcon />
          </IconButton>
        </Box>

        {/* Content Scrollable */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "hidden",
            mb: 2,
          }}
        >
          {children}
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          <Button {...cancelProps}>{cancelText}</Button>
          <Button {...submitProps} variant="outlined">{submitText}</Button>
        </Box>
      </Box>
    </Modal>
  );
}
